import React from 'react'
import FilterGroup from './FilterGroup'
import TagsFilter from './TagsFilter'
import { toggleSelection } from '../utils/helpers'
import { translations, categoryLabels } from '../data/translations'

const CardFilters = ({
  filtersOpen,
  setFiltersOpen,
  costFilter,
  setCostFilter,
  powerFilter,
  setPowerFilter,
  selectedSeries,
  setSelectedSeries,
  selectedTypes,
  setSelectedTypes,
  language,
}) => {
  const t = translations[language]

  return (
    <div className="filters">
      <button
        className="filters__toggle"
        onClick={() => setFiltersOpen(!filtersOpen)}
      >
        <span className="filters__toggle-text">{t.filters.filtersTitle}</span>
        <div className={`filters__toggle-icon ${filtersOpen ? 'open' : ''}`} />
      </button>
      <div className={`filters__content ${filtersOpen ? 'active' : ''}`}>
        <div className="filters__wrapper">
          <FilterGroup
            title={t.filters.cost}
            options={['0', '1', '2', '3', '4', '5', '6', '7', '8']}
            selected={costFilter}
            onToggle={(val) => toggleSelection(costFilter, val, setCostFilter)}
            type="cost"
          />
          <FilterGroup
            title={t.filters.power}
            options={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']}
            selected={powerFilter}
            onToggle={(val) =>
              toggleSelection(powerFilter, val, setPowerFilter)
            }
            type="power"
          />
          <TagsFilter
            title={t.filters.tags}
            tags={[
              'Series 1',
              'Series 2',
              'Series 3',
              'Series 4',
              'Series 5',
              'Not Available',
              'Season Pass',
              'Available',
              'None',
              'Starter Card',
              'Collection Level 1-14',
              'Recruit Season',
              'Activate',
              'Destroy',
              'Discard',
              'End of Turn',
              'Game Start',
              'Start of Game',
              'Move',
              'No Ability',
              'On Reveal',
              'Ongoing',
              'Skill',
            ]}
            selected={[...selectedSeries, ...selectedTypes]}
            onToggle={(tag) => {
              const seriesTags = [
                'Series 1',
                'Series 2',
                'Series 3',
                'Series 4',
                'Series 5',
                'Not Available',
                'Season Pass',
                'Available',
                'None',
                'Starter Card',
                'Collection Level 1-14',
                'Recruit Season',
              ]
              if (seriesTags.includes(tag)) {
                toggleSelection(selectedSeries, tag, setSelectedSeries)
              } else {
                toggleSelection(selectedTypes, tag, setSelectedTypes)
              }
            }}
            language={language}
            categoryLabels={categoryLabels}
          />
        </div>
      </div>
    </div>
  )
}

export default CardFilters
